import styled from 'styled-components'

import { DistributionCommon } from './distribution-common'
import { DistributionLine } from './distribution-line'
import { DistributionTable } from './distribution-table'

import type { DistributeRange } from '@root/features/profile/distribute-drawer/model'

export type DistributionProps = {
  distribution: ReadonlyArray<{
    range: DistributeRange
    color: string
    border: string
    count: string
    percentage: React.ReactNode
    percentageValue: number | undefined
  }>
}

export const Distribution = (
  props: DistributionProps & { onClick: () => void },
) => {
  return (
    <DistributionCommon onClick={props.onClick}>
      <Main>
        <DistributionLine distribution={props.distribution} />
        <DistributionTable distribution={props.distribution} />
      </Main>
    </DistributionCommon>
  )
}

const Main = styled.div`
  display: grid;
  height: 100%;
  grid-template-rows: auto;
  grid-auto-rows: 1fr;
  gap: 18px;
`
